// extracted by mini-css-extract-plugin
export default {"Wrapper":"ContractDocumentsActions_Wrapper__WBwpk"};